module.exports = __webpack_public_path__ + "static/media/abt_icon5.4e6657f4.svg";